import { render, staticRenderFns } from "./basement.vue?vue&type=template&id=33dd5252"
import script from "./basement.vue?vue&type=script&lang=js"
export * from "./basement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/basement/basement.vue
// module id = kc8E
// module chunks = 0